<template>
  <Page :response="response">
    <CustomerForm :customer="resource"
                  @formSubmit="saveFormSubmitted($event)"
                  @clickDestroy="clickDestroy($event)" />
  </Page>
</template>

<script>
import store from "./CustomerStore";

import CustomerForm from "./CustomerForm.vue";
import CustomerMixin from "./CustomerMixin";

const responseStore = {
  response: null
};

const fetchResource = async (to, from, next) => {
  responseStore.response = await store.fetch(to.params.id);

  next();
};

export default {
  name: "CustomerEdit",

  title () {
    return `Edit Customer - ${Dashboard.currentTenant.name}`;
  },

  components: {
    CustomerForm
  },

  mixins: [CustomerMixin],

  beforeRouteEnter: fetchResource,
  beforeRouteUpdate: fetchResource,

  data () {
    return {
      responseStore: responseStore,
      store: store
    };
  },

  mounted () {
    this.addBreadcrumb(`${this.resource.display_name} / Edit`);
  }
};
</script>
